module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "Work"
  }, [_c('div', {
    staticClass: "Work-content"
  }, [_c('div', {
    staticClass: "Work-contentWrapper",
    attrs: {
      "scrollbar": ""
    }
  }, [_c('div', {
    staticClass: "Work-imgSet"
  }, [_c('div', {
    staticClass: "Work-imgSetWrapper"
  }, _vm._l((_vm.work.imgSet), function(img) {
    return _c('img', {
      attrs: {
        "data-aos": "fade-up",
        "src": img.src,
        "alt": img.alt
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "Work-next"
  }, [_c('div', {
    staticClass: "Work-nextWrapper"
  }, [_c('div', {
    staticClass: "Work-nextText",
    attrs: {
      "data-aos": "fade"
    }
  }, [_vm._v("Projet suivant")]), _vm._v(" "), _c('div', {
    staticClass: "Work-nextWork",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('figure', {
    staticClass: "Work-nextFigure"
  }, [_c('img', {
    attrs: {
      "src": _vm.work.thumbImg.src,
      "alt": _vm.work.thumbImg.alt
    }
  }), _vm._v(" "), _c('figcaption', [_c('div', [_vm._v(_vm._s(_vm.work.thumbImg.alt))])]), _vm._v(" "), _c('a', {
    staticClass: "Work-nextLink",
    attrs: {
      "href": '/work/' + _vm.work.next + '/'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNext.apply(null, arguments)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "Work-closeBtn"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span'), _c('span'), _c('span'), _c('span')])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "WorkLanding"
  }, [_c('figure', {
    staticClass: "WorkLanding-wrapper"
  }, [_c('div', {
    staticClass: "WorkLanding-img",
    style: (_vm.work.landingImg)
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "WorkLanding-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.work.title))]), _vm._v(" "), _c('ul', {
    staticClass: "WorkLanding-fields"
  }, _vm._l((_vm.work.fields), function(f) {
    return _c('li', [_vm._v(_vm._s(f))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "WorkLanding-description"
  }, [_vm._v(_vm._s(_vm.work.description))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-055ba2d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Work.vue
// module id = 213
// module chunks = 0